export const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
        const offset = section.offsetTop;
        window.scrollTo({
            top: offset,
            behavior: 'smooth',
        });
    }
};